import type {SVGProps} from 'react'
const QrIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    {...props}
  >
    <rect x={3.5} y={3.5} width={5} height={5} rx={1} fill="none" stroke="currentColor" />
    <rect x={3.5} y={11.5} width={5} height={5} rx={1} fill="none" stroke="currentColor" />
    <rect x={11.5} y={3.5} width={5} height={5} rx={1} fill="none" stroke="currentColor" />
    <rect x={11} y={11} width={2} height={2} />
    <rect x={13} y={13} width={2} height={2} />
    <rect x={11} y={15} width={2} height={2} />
    <rect x={15} y={15} width={2} height={2} />
    <rect x={15} y={11} width={2} height={2} />
  </svg>
)
export {QrIcon}
